import React from 'react';

import AssistantChat from 'views/scenes/assistant/AssistantChat';

const App = (props) => {
  return (
    <>
      <AssistantChat

      />
    </>
  );
};

export default App;
